export default __webpack_public_path__ + "static/media/switch2.e4576f91.svg";